import CustomInput from '../../../../../components/forms/CustomInput';

const CheckoutBillingForm = ({
  isExternalCustomLink,
  businessName,
  setBusinessName,
  customDeal,
  billingEmail,
  setBillingEmail,
  gstinNumber,
  billingState,
  setBillingState,
  pincode,
  setPincode
}) => {
  if (isExternalCustomLink) {
    return (
      <section className="rounded-2xl sm:rounded-3xl border border-slate-200 bg-white p-4 sm:p-6 shadow-sm space-y-3.5 sm:space-y-4">
        <div>
          <span className="text-[11px] sm:text-xs font-bold uppercase tracking-wider text-[#067978]">Step 3</span>
          <h2 className="text-base sm:text-lg font-semibold text-slate-900 mt-0.5 font-sans">Billing &amp; Tax details</h2>
          <p className="text-xs text-slate-500 mt-0.5 font-normal">Pre-configured for this agency deal. Appears on your GST tax invoice.</p>
        </div>

        <div className="p-3.5 sm:p-4 rounded-xl sm:rounded-2xl bg-slate-50 border border-slate-200/80 space-y-2.5 text-xs text-slate-700 font-sans">
          <div className="flex justify-between items-center border-b border-slate-200/60 pb-2">
            <span className="text-slate-500 font-medium">Billed Agency:</span>
            <span className="font-semibold text-slate-800">{businessName || customDeal?.agent_name || 'Registered Agency'}</span>
          </div>
          <div className="flex justify-between items-center border-b border-slate-200/60 pb-2">
            <span className="text-slate-500 font-medium">Account Email:</span>
            <span className="text-slate-800">{billingEmail || 'Official Account Email'}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-slate-500 font-medium">Tax Calculation:</span>
            <span className="font-medium text-[#067978]">{gstinNumber ? `GSTIN: ${gstinNumber}` : 'Default State Split (CGST 9% + SGST 9%)'}</span>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="rounded-2xl sm:rounded-3xl border border-slate-200 bg-white p-4 sm:p-6 shadow-sm space-y-3.5 sm:space-y-4">
      <div>
        <span className="text-[11px] sm:text-xs font-bold uppercase tracking-wider text-[#067978]">Step 3</span>
        <h2 className="text-base sm:text-lg font-semibold text-slate-900 mt-0.5">Billing details</h2>
        <p className="text-xs text-slate-500 mt-0.5 font-normal">Appears on your GST invoice, emailed after payment.</p>
      </div>

      <div className="space-y-3 sm:space-y-3.5">
        <CustomInput
          label="Registered Business Name"
          type="text"
          value={businessName}
          onChange={(e) => setBusinessName(e.target.value)}
          placeholder="e.g. Acme Travels"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-3.5">
          <CustomInput
            label="Billing State"
            type="text"
            value={billingState}
            onChange={(e) => setBillingState(e.target.value)}
            placeholder="e.g. Maharashtra"
          />
          <CustomInput
            label="Pincode"
            type="text"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            placeholder="e.g. 400001"
          />
        </div>

        <CustomInput
          label="Billing Email"
          type="email"
          value={billingEmail}
          onChange={(e) => setBillingEmail(e.target.value)}
          placeholder="e.g. accounts@agency.com"
        />
      </div>
    </section>
  );
};

export default CheckoutBillingForm;
